module.exports = __webpack_public_path__ + "sl.svg?af9693c48df40e656ba246984fe76fe9";